import get from "lodash/get";

import { DEVICE_ID, UPLOADED } from "../../constants";
import { getIsEditableStatusSearchInfo } from "./searchProspect";
import { ensureBearerToken } from "../../utils/genericUtils";

export const getAgentName = state => state.appConfig.login.userName;

export const agentLoginStatus = state => state.login.loginStatus;

export const getAppConfig = state => state.appConfig || {};

export const getDatalist = state => getAppConfig(state).datalist || {};

export const getSignatoryModel = state => getAppConfig(state).signatoryModel || {};

export const getOrganizationInfoModel = state => getAppConfig(state).organizationInfoModel || {};

export const getReCaptchaSiteKey = state => getAppConfig(state).reCaptchaSiteKey;

export const getIsRecaptchaEnable = state => getAppConfig(state).recaptchaEnable;

export const getServicePricingGuideUrl = state => getAppConfig(state).servicePricingGuideUrl;

export const getAuthToken = state => getAppConfig(state).authorizationToken;
export const getRefreshToken = state => getAppConfig(state).refreshToken || undefined;

export const getProspect = state => getAppConfig(state).prospect || {};

export const getFreeFieldsInfo = state => getProspect(state).freeFieldsInfo || {};
export const getInitialProspectTableCheck = state => getAppConfig(state).initialProspectTableCheck;

export const getSignatories = state => getProspect(state).signatoryInfo || [];

export const getInitialKycEditCheck = state => getAppConfig(state).iskycInitialEdit;

export const getSignatoriesCount = state => getSignatories(state).length;

export const getAccountInfo = state => getProspect(state).accountInfo || [];

export const getAccountCurrencies = state => get(getAccountInfo(state)[0], "accountCurrencies", "");

export const getExpressTandC = state => get(getAccountInfo(state)[0], "expressTandC", false);

export const getOrganizationInfo = state => getProspect(state).organizationInfo || {};

export const getKycAnnexureDetails = state => getProspect(state).kycAnnexure || {};

export const getPrimaryMobCountryCode = state =>
  get(getOrganizationInfo(state), "contactDetails.primaryMobCountryCode", "");

export const getCompanyName = state => getOrganizationInfo(state).companyName;

export const getOrgKYCDetails = state => getProspect(state).orgKYCDetails || {};

export const getGeneralInfo = state => getProspect(state).generalInfo || {};

export const getProspectId = state => getGeneralInfo(state).prospectId || "";

export const getApplicantInfo = state => getProspect(state).applicantInfo || {};

export const getApplicantFullName = state => getApplicantInfo(state).fullName;

// ro-assist-brd3-3
export const getValidRoCode = state => {
  const validRoCode = getApplicantInfo(state).validRoCode || "N";
  return validRoCode === "Y" ? true : false;
};

export const getApplicationInfo = state => getProspect(state).applicationInfo || {};

export const getIsIslamicBanking = state => getApplicationInfo(state).islamicBanking;

export const getAccountType = state => getApplicationInfo(state).accountType;

export const getRakValuePackage = state => getApplicationInfo(state).rakValuePackage || "";

export const getDocuments = state => getProspect(state).documents || {};

export const getCompanyDocuments = state => getDocuments(state).companyDocuments || [];

export const getCompanyBankStatements = state => getDocuments(state).companyBankStatements || [];

export const getCompanyAddressProof = state => getDocuments(state).companyAddressProof || [];

export const getCompanyInvoices = state => getDocuments(state).companyInvoices || [];

export const getMobileNumber = state => getProspect(state).applicantInfo?.mobileNo || "";

export const getDocumentUploadCnt = state => {
  const companyDocuments = getCompanyDocuments(state);
  let DocumentUploadCnt = 0;
  if (companyDocuments[0]) {
    DocumentUploadCnt = companyDocuments[0].DocumentUploadCnt;
  }
  return DocumentUploadCnt;
};

export const getStakeholdersDocuments = state => getDocuments(state).stakeholdersDocuments || [];

export const getKycAnnexureDocuments = state => getDocuments(state).kycAnnexureDocuments || [];

export const getOtherDocuments = state => getDocuments(state).otherDocuments || [];

export const checkIfRequiredDocsUploaded = docs =>
  docs.length && docs.filter(doc => doc.required).every(doc => doc.uploadStatus === UPLOADED);

export const checkRequiredKycAnnexureDocs = state => {
  const kycAnnexureDocuments = getKycAnnexureDocuments(state);
  const isComeFromROScreens = getIsEditableStatusSearchInfo(state);
  const orgKYCDetails = getOrgKYCDetails(state);
  const hawalaService = isComeFromROScreens && orgKYCDetails?.hawalaService === "yes";
  const isCompanyUSEntity = isComeFromROScreens && orgKYCDetails?.isCompanyUSEntity === true;

  return kycAnnexureDocuments.map(doc => {
    const { documentType } = doc;
    const isHawalaDoc = documentType?.includes("Hawala") && hawalaService;
    const isCompanyUSEntityDoc =
      (documentType?.includes("W8") || documentType?.includes("W9")) && isCompanyUSEntity;
    return {
      ...doc,
      required: isHawalaDoc || isCompanyUSEntityDoc ? true : doc.required
    };
  });
};

export const getIsRequiredDocsUploaded = state => {
  // ro-assist-brd3-3 starts
  if (getValidRoCode(state)) {
    return true;
  }
  // // ro-assist-brd3-3 end
  const { companyDocuments, stakeholdersDocuments } = getDocuments(state);
  // ro-assist-brd2-1
  const companyBankStatements = getCompanyBankStatements(state).documents || [];
  const companyAddressProof = getCompanyAddressProof(state).documents || [];
  const companyInvoices = getCompanyInvoices(state).documents || [];
  const stakeholdersDocsFlattened = Object.values(stakeholdersDocuments || {}).reduce(
    (acc, { documents, personalBankStatements, personalBackground }) => [
      ...acc,
      ...documents,
      ...(personalBankStatements ? personalBankStatements.documents : []),
      ...(personalBackground ? personalBackground.documents : [])
    ],
    []
  );
  const kycAnnexureDocuments = checkRequiredKycAnnexureDocs(state);

  return checkIfRequiredDocsUploaded([
    ...(companyDocuments || []),
    ...(kycAnnexureDocuments || []),
    ...companyBankStatements,
    ...companyAddressProof,
    ...companyInvoices,
    ...stakeholdersDocsFlattened
  ]);
};

export const getUrlsReadMore = state => ({
  rakValuePlusReadMoreUrl:
    "https://www.rakbank.ae/en/business/business-solutions/other-solutions/rakvalue-sme-packages",
  rakValueMaxReadMoreUrl:
    "https://www.rakbank.ae/en/business/business-solutions/other-solutions/rakvalue-sme-packages",
  rakValuePlusIslamicReadMoreUrl:
    "https://www.rakbank.ae/en/islamic/business/everyday-banking/accounts/rakvalue-sme",
  rakValueMaxIslamicReadMoreUrl:
    "https://www.rakbank.ae/en/islamic/business/everyday-banking/accounts/rakvalue-sme"
});

export const getAuthorizationHeader = state => {
  const authToken = getAuthToken(state);
  const refreshToken = getRefreshToken(state);
  const deviceId = getDeviceID(state);

  const isAgentLoggedIn = agentLoginStatus(state);
  const mobileNo = getMobileNumber(state);
  const prospectId = getProspectId(state);
  const headers = authToken ? { Authorization: ensureBearerToken(authToken) } : {};
  headers["mobile-no"] = mobileNo;
  headers["prospect-id"] = prospectId;
  headers["stage-id"] = getApplicationInfo(state).viewId;
  headers["device-id"] = deviceId;

  if (refreshToken) {
    headers["refresh-token"] = refreshToken;
  }

  if (isAgentLoggedIn) {
    const agentName = getAgentName(state);
    if (agentName) {
      headers["user-id"] = agentName;
    }
  }
  return {
    headers: Object.keys(headers).length > 0 ? headers : {}
  };
};

export const isAuthorizationHeaderLoaded = state => {
  const authToken = getAuthToken(state);
  return authToken ? true : false;
};

export const createGetAuthorityTypeDisplayText = authorityType => state => {
  const authorityTypeFromDatalist =
    getDatalist(state).authorityType.find(item => item.value === authorityType) || {};

  return authorityTypeFromDatalist.displayText || "";
};

export const getLeadSource = state => {
  return typeof state.appConfig.leadSource !== "undefined"
    ? state.appConfig.leadSource.productName
    : "";
};

export const getRoCode = state => {
  return typeof state.appConfig.roCode !== "undefined" ? state.appConfig.roCode : "";
};

export const getExpired = state => getAppConfig(state).expired;

export const getIsLemniskEnable = state => {
  return typeof state.appConfig.lemniskEnable !== "undefined"
    ? state.appConfig.lemniskEnable
    : false;
};

export const getAdditionalConfigs = state => getAppConfig(state).additionalConfigs || {};
export const isComebackJourney = state => getAppConfig(state).comebackJourney || false;
export const getDocumentTypes = state => getAppConfig(state).documentTypes || [];
export const getDeviceID = state => getAppConfig(state).deviceId || DEVICE_ID;
